module.exports = __webpack_public_path__ + "img/squilliam_fancyson.e7c09f29.jpg";